module.exports = __webpack_public_path__ + "static/WEDDING E&M-193-f930af443fc762fed2e498cf2a860a5d.jpg";